// components/Loader/Loader.jsx
import React, {forwardRef, useRef, useImperativeHandle} from "react";
import {gsap} from "gsap";
import "./Loader.css";

const Loader = forwardRef((_, ref) => {
  const wrapperRef = useRef(null);
  const svgRef = useRef(null);
  const textRef = useRef(null);

  useImperativeHandle(ref, () => ({
    play: () => {
      if (!wrapperRef.current || !svgRef.current) return;

      const curve = "M0 502S175 272 500 272s500 230 500 230V0H0Z";
      const flat = "M0 2S175 1 500 1s500 1 500 1V0H0Z";

      // Reset everything before animation
      gsap.set(wrapperRef.current, {
        y: 0,
        opacity: 1,
        zIndex: 9999,
        display: "flex",
      });

      gsap.set(textRef.current, {
        opacity: 1,
        y: 0,
      });

      gsap.set(svgRef.current, {
        attr: {d: "M0,1005S175,995,500,995s500,5,500,5V0H0Z"},
      });

      const tl = gsap.timeline();

      tl.to(textRef.current, {
        delay: 0.8,
        y: -100,
        opacity: 0,
        duration: 0.5,
        ease: "power2.out",
      })
        .to(svgRef.current, {
          duration: 0.5,
          attr: {d: curve},
          ease: "power2.easeIn",
        })
        .to(svgRef.current, {
          duration: 0.5,
          attr: {d: flat},
          ease: "power2.easeOut",
        })
        .to(wrapperRef.current, {
          delay: 0.5,
          y: -1500,
          duration: 0.5,
          ease: "power2.inOut",
        })
        .set(wrapperRef.current, {
          zIndex: -1,
          display: "none",
        });
    },
  }));

  return (
    <div className="Loader" ref={wrapperRef}>
      <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
        <path
          id="LoaderSvg"
          ref={svgRef}
          d="M0,1005S175,995,500,995s500,5,500,5V0H0Z"
        />
      </svg>
      <div className="Loader-heading">
        <div className="load-text" ref={textRef}>
          <span>D</span>
          <span>E</span>
          <span>E</span>
          <span>P</span>
          &nbsp;
          <span>K</span>
          <span>A</span>
          <span>P</span>
          <span>A</span>
          <span>D</span>
          <span>I</span>
          <span>A</span>
        </div>
      </div>
    </div>
  );
});

export default Loader;
